import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import heroImg from '../hero.png';

export default function Hero({ onGetStarted }) {
  const reduce = useReducedMotion();

  return (
    <section id="home" className="relative overflow-hidden bg-black pt-24 pb-12 md:pt-32 md:pb-16">
      {/* soft radial washes like IntelliLabs */}
      <div className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-accent/20 blur-[120px]" />
      <div className="pointer-events-none absolute -right-20 top-40 h-[380px] w-[380px] rounded-full bg-accent-violet/15 blur-[100px]" />

      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:px-12">
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="pill-dark">Commerce Operating System</span>

          <h1 className="mt-6 text-4xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-5xl md:text-6xl">
            Run your store from{' '}
            <span className="grad-text">one system</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-mute sm:text-lg">
            Branded customer app, counter billing, multi-branch stock, delivery, offers, and returns.
            Built so your whole team can use it without a long training day.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <button type="button" onClick={onGetStarted} className="btn-grad">
              Get Started
            </button>
            <RouterLink to="/platform" className="btn-ghost">
              View Our Platform
            </RouterLink>
          </div>
        </motion.div>

        <motion.div
          initial={reduce ? false : { opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="relative z-10"
        >
          <div className="pointer-events-none absolute -inset-2 -z-10 rounded-[1.75rem] bg-accent/10 blur-xl" />
          <img
            src={heroImg}
            alt="Zuntly retail platform preview"
            width={1661}
            height={947}
            decoding="async"
            className="img-glow relative z-10 h-auto w-full object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
}
